import axios from 'axios';
import store from 'store';

const productKey = 'viewed-products-3';
const previousProductsMaxCount = 19;

const getLocalStorageProducts = () => store.get(productKey) || [];

const fetchProducts = async () => {
  const localStorageProducts = getLocalStorageProducts();
  if (localStorageProducts.length === 0) {
    return [];
  }
  const products = await axios.post('/Catalog/PreviousViewedProduct/Get', localStorageProducts);
  return products.data;
};

const updateLocalStorage = (products) => store.set(productKey, products);

const updatePreviousProducts = async (product) => {
  const previousProducts = await getLocalStorageProducts();
  let oldProducts = previousProducts.filter((p) => product.productId !== p.productId);

  oldProducts = oldProducts.slice(0, previousProductsMaxCount);

  const newProducts = [product].concat(oldProducts);

  updateLocalStorage(newProducts);
};

module.exports = {
  fetchProducts,
  updatePreviousProducts,
};
